export const mp4MimeTypes = ["application/mp4", "video/mp4"];
